import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { UpcomingAppointments } from '@/components/dashboard/UpcomingAppointments';
import { useProfileSetup } from '@/hooks/useProfileSetup';
import { MainLayout } from '@/components/MainLayout';
import { SalesRepMetrics } from '@/components/dashboard/SalesRepMetrics';
import { TeamLeaderMetrics } from '@/components/dashboard/TeamLeaderMetrics';
import { AdminMetrics } from '@/components/dashboard/AdminMetrics';

const Dashboard = () => {
  const {
    user,
    userRole,
    loading,
    isImpersonating,
    impersonatedUserRole,
    hasPermission
  } = useAuth();
  const navigate = useNavigate();
  const { profileCompleted, refetch: refetchProfile } = useProfileSetup();

  // Use impersonated role if impersonating, otherwise use actual role
  const effectiveRole = isImpersonating ? impersonatedUserRole : userRole;
  
  useEffect(() => {
    if (!loading && !user) {
      navigate('/auth');
    }
  }, [user, loading, navigate]);
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Loading...</div>
      </div>
    );
  }

  return (
    <MainLayout 
      title="Dashboard" 
      subtitle={effectiveRole === 'admin' ? 'Admin' : 'Sales Rep'}
    >
      {/* Role-based metrics */}
      {effectiveRole === 'sales_rep' && user && <SalesRepMetrics userId={user.id} />}
      {effectiveRole === 'team_leader' && user && <TeamLeaderMetrics userId={user.id} />}
      {(effectiveRole === 'super_admin' || effectiveRole === 'sales_admin') && <AdminMetrics />}

      {/* Upcoming appointments for all roles */}
      <div className="mt-8">
        <UpcomingAppointments />
      </div>
      
      {/* Onboarding disabled temporarily */}
      {/* <ProfileSetupModal open={!profileCompleted} onComplete={refetchProfile} /> */}
    </MainLayout>
  );
};

export default Dashboard;